// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "CatalogueImportsView" + "." + "96730e6c" + ".chunk.css";
};